import * as React from 'react';

export const RootGridIcon = (icon?: any): JSX.Element => {
	let svgGridIcon: any;
	if (icon.variant === 'ver-ingresos') {
		svgGridIcon = (
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 60">
				<title>Ver ingresos</title>
				<line x1="28.12" y1="17.95" x2="28.12" y2="42.85" />
				<ellipse cx="16.53" cy="42.85" rx="4.25" ry="4.2" />
				<ellipse cx="43.97" cy="42.85" rx="4.25" ry="4.2" />
				<path d="M48.22,42.85H51.8a1.22,1.22,0,0,0,1.2-1l.62-2.84a3.54,3.54,0,0,0-2.91-4.24l-11-1.66L37.8,28.63a5,5,0,0,0-4.58-2.92H14.35a5.79,5.79,0,0,0-5.43,3.74l-.73,2a17.88,17.88,0,0,0-1.13,6.27V41.1a1.76,1.76,0,0,0,1.77,1.75h3.46" />
				<line x1="20.77" y1="42.85" x2="39.72" y2="42.85" />
				<rect x="23.06" y="17.95" width="10.27" height="5.17" />
				<rect x="12.28" y="14.4" width="7.51" height="8.73" />
			</svg>
		);
	} else if (icon.variant === 'ver-egresos') {
		svgGridIcon = (
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 60">
				<title>Ver egresos</title>
				<path d="M19.06,42.93h0a2.6,2.6,0,0,1,2.6,2.6v9.06a0,0,0,0,1,0,0h-5.2a0,0,0,0,1,0,0V45.53A2.6,2.6,0,0,1,19.06,42.93Z" />
				<path d="M39.88,42.93h0a2.6,2.6,0,0,1,2.6,2.6v9.06a0,0,0,0,1,0,0h-5.2a0,0,0,0,1,0,0V45.53A2.6,2.6,0,0,1,39.88,42.93Z" />
				<rect x="11.79" y="14.3" width="34.99" height="40.29" />
				<rect x="17.51" y="7.94" width="23.57" height="6.36" />
				<path d="M29.32,42.93a4.15,4.15,0,0,0-4.11,4.19v7.48h8.22V47.11A4.15,4.15,0,0,0,29.32,42.93Z" />
				<line x1="32.98" y1="27.22" x2="32.98" y2="29.91" />
				<line x1="25.96" y1="29.91" x2="25.96" y2="27.22" />
				<line x1="32.98" y1="19.6" x2="32.98" y2="22.06" />
				<line x1="25.96" y1="22.06" x2="25.96" y2="19.6" />
				<line x1="40" y1="29.91" x2="40" y2="27.22" />
				<line x1="40" y1="22.06" x2="40" y2="19.6" />
				<line x1="18.94" y1="27.22" x2="18.94" y2="29.91" />
				<line x1="32.98" y1="35.19" x2="32.98" y2="37.87" />
				<line x1="25.96" y1="37.87" x2="25.96" y2="35.19" />
				<line x1="40" y1="37.87" x2="40" y2="35.19" />
				<line x1="18.94" y1="35.19" x2="18.94" y2="37.87" />
				<line x1="18.94" y1="19.6" x2="18.94" y2="22.06" />
				<line x1="22.51" y1="11.12" x2="36.07" y2="11.12" />
			</svg>
		);
	} else if (icon.variant === 'ver-caja') {
		svgGridIcon = (
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 60">
				<title>Ver caja</title>
				<path d="M49.83,30.06s-8.42,6.3-18.29,6.3a45,45,0,0,1-18.29-4.3v-4a45,45,0,0,1,18.29-4.3c9.87,0,18.29,6.3,18.29,6.3" />
				<line x1="21.6" y1="20.26" x2="29.41" y2="27.96" />
				<path d="M21.6,20.26,19.8,22l-3.06-3a2,2,0,0,1,0-2.86l.36-.35.36-.35a2.07,2.07,0,0,1,2.9,0l3.06,3L21.6,20.26" />
				<line x1="41.47" y1="39.86" x2="33.67" y2="32.16" />
				<path d="M41.47,39.86l-1.81,1.78,3.06,3a2.07,2.07,0,0,0,2.9,0l.36-.35.36-.35a2,2,0,0,0,0-2.86l-3.06-3-1.81,1.78" />
				<line x1="13.25" y1="41.82" x2="24.74" y2="41.82" />
				<line x1="7.45" y1="20.4" x2="11.53" y2="20.4" />
				<line x1="30.26" y1="17.46" x2="44.31" y2="17.46" />
				<line x1="50.7" y1="38.46" x2="53.25" y2="38.46" />
				<ellipse cx="31.54" cy="30.06" rx="2.61" ry="2.58" />
			</svg>
		);
	} else if (icon.variant === 'nuevo-ingreso') {
		svgGridIcon = (
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 60">
				<title>Nuevo ingreso</title>
				<line x1="29.71" y1="44.5" x2="29.71" y2="34.07" />
				<polygon points="37.49 34.07 21.65 34.07 19.34 31.46 21.65 28.86 37.49 28.86 37.49 34.07" />
				<line x1="29.71" y1="28.86" x2="29.71" y2="24.51" />
				<line x1="29.71" y1="19.3" x2="29.71" y2="15.24" />
				<line x1="14.45" y1="44.5" x2="44.97" y2="44.5" />
				<polygon points="21.65 19.3 37.49 19.3 39.79 21.9 37.49 24.51 21.65 24.51 21.65 19.3" />
			</svg>
		);
	} else if (icon.variant === 'nuevo-egreso') {
		svgGridIcon = (
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 60">
				<title>Nuevo egreso</title>
				<line x1="12.88" y1="37.97" x2="7.47" y2="37.97" />
				<line x1="34.51" y1="37.97" x2="23.69" y2="37.97" />
				<path d="M12,23.77H34.88a16.25,16.25,0,0,1,10,3.44l7.08,5.51A2.94,2.94,0,0,1,53.08,35h0A2.92,2.92,0,0,1,50.18,38H45.33" />
				<line x1="38.84" y1="29.05" x2="36.75" y2="29.05" />
				<line x1="32.87" y1="29.05" x2="30.78" y2="29.05" />
				<line x1="26.9" y1="29.05" x2="24.81" y2="29.05" />
				<line x1="20.93" y1="29.05" x2="18.84" y2="29.05" />
				<line x1="14.96" y1="29.05" x2="12.88" y2="29.05" />
				<ellipse cx="43.16" cy="38.15" rx="2.16" ry="2.19" />
				<ellipse cx="36.67" cy="38.15" rx="2.16" ry="2.19" />
				<ellipse cx="21.53" cy="38.15" rx="2.16" ry="2.19" />
				<ellipse cx="15.04" cy="38.15" rx="2.16" ry="2.19" />
				<line x1="16.69" y1="19.34" x2="11.49" y2="19.34" />
				<line x1="8.43" y1="19.34" x2="7.82" y2="19.34" />
				<line x1="47.44" y1="23.77" x2="46.14" y2="22.92" />
				<line x1="54.12" y1="28.95" x2="49.75" y2="25.56" />
			</svg>
		);
	} else if (icon.variant === 'nuevo-registro') {
		svgGridIcon = (
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 60">
				<title>Nuevo registro</title>
				<line x1="24.69" y1="22.03" x2="22.39" y2="24.36" />
				<line x1="15.72" y1="31.12" x2="13.43" y2="33.44" />
				<line x1="20.31" y1="26.47" x2="18.01" y2="28.79" />
				<line x1="46.44" y1="33.29" x2="44.15" y2="30.97" />
				<line x1="37.47" y1="24.21" x2="35.18" y2="21.88" />
				<line x1="42.06" y1="28.86" x2="39.77" y2="26.53" />
				<path d="M29.86,27.18,18,15.27l-2.92,3a3.92,3.92,0,0,1,0,5.49,3.8,3.8,0,0,1-5.42,0l-2.92,3,15,15.24,3.34-3.39" />
				<path d="M50.49,23.27a3.8,3.8,0,0,1-5.42,0,3.92,3.92,0,0,1,0-5.49l-2.92-3L21.94,35.3,33.2,46.7,53.41,26.23Z" />
				<line x1="39.46" y1="35.3" x2="32.99" y2="41.85" />
				<line x1="34.06" y1="36.6" x2="30.91" y2="39.73" />
			</svg>
		);
	} else {
		svgGridIcon = <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 60" />;
	}
	return svgGridIcon;
};
